import { useState, useEffect } from 'react';
export default function useOnnitContext() {
    var _a = useState(null), onnitContext = _a[0], setOnnitContext = _a[1];
    useEffect(function () {
        if (window) {
            if (window.onnit_context) {
                setOnnitContext(window.onnit_context);
            }
        }
    }, []);
    return onnitContext ? onnitContext : null;
}
//# sourceMappingURL=useOnnitContext.js.map